import { render, staticRenderFns } from "./BeforeQuestion.vue?vue&type=template&id=34cd1456"
import script from "./BeforeQuestion.vue?vue&type=script&lang=js"
export * from "./BeforeQuestion.vue?vue&type=script&lang=js"
import style0 from "./BeforeQuestion.vue?vue&type=style&index=0&id=34cd1456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports